import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function About() {
  return (
    <div>
      <Header />
      <main style={{ padding: 24 }}>
        <h1>About MyFleetPulse</h1>
        <p>Vehicle maintenance management for owners and fleets.</p>
        <p>We combine vehicle tracking with AI insights and smart reminders.</p>
      </main>
      <Footer />
    </div>
  );
}
